import React, { ReactElement } from 'react'

import { ColorOrCurrent } from '../../../../types/colorOrCurrent'
import { Icon, IconName } from '../../../Icon'

interface NavIconProps {
  icon: IconName
  color?: ColorOrCurrent
}

export const NavIcon = ({ color, icon }: NavIconProps): ReactElement => (
  <Icon icon={icon} color={color || 'currentColor'} />
)
